// Widget Scripts
import cardWidgetQuickLink from './js/widgets/cardWidgetQuickLink.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import cardWidget from './js/widgets/cardWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import sponsors from './js/widgets/sponsors.js';

// Custom Theme Scripts
import './js/localjs.js';
import './js/siteInfoBanner.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    swiperWidget();
    multiScheduleFeature();
    cardWidget();
    videoWidget();
    seoWidget();
    sponsors();
  });
}

$(document).ready(function () {
  cardWidgetQuickLink();
});
